import { render, staticRenderFns } from "./PageDocStockAide.vue?vue&type=template&id=4fe60184&"
import script from "./PageDocStockAide.vue?vue&type=script&lang=js&"
export * from "./PageDocStockAide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe60184')) {
      api.createRecord('4fe60184', component.options)
    } else {
      api.reload('4fe60184', component.options)
    }
    module.hot.accept("./PageDocStockAide.vue?vue&type=template&id=4fe60184&", function () {
      api.rerender('4fe60184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Stocks/PageDocStockAide.vue"
export default component.exports